import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const API = 'https://tribaltech-backend.onrender.com';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setSent(true);
    } catch (e) {
      setError(e.message || 'Something went wrong');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)' }}>
      <div style={{ width: 400 }}>
        <div style={{ textAlign:'center', marginBottom: 32 }}>
          <div style={{ fontSize: 24, fontWeight: 700, color: 'var(--purple-light)', marginBottom: 8 }}>CREATOR PROTECT</div>
          <div style={{ color: 'var(--muted)', fontSize: 14 }}>Content protection for creators</div>
        </div>

        <div className="card">
          {sent ? (
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <div style={{ fontSize: 40, marginBottom: 16 }}>📧</div>
              <h2 style={{ marginBottom: 12, fontSize: 18 }}>Check your email</h2>
              <p style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.6, marginBottom: 24 }}>
                If an account exists for <strong style={{ color: 'var(--offwhite)' }}>{email}</strong>, we've sent a password reset link. Check your inbox and spam folder.
              </p>
              <Link to="/login" style={{ color: 'var(--purple-light)', fontSize: 14 }}>← Back to sign in</Link>
            </div>
          ) : (
            <>
              <h2 style={{ marginBottom: 8, fontSize: 18 }}>Forgot your password?</h2>
              <p style={{ color: 'var(--muted)', fontSize: 14, marginBottom: 24, lineHeight: 1.6 }}>
                Enter your email and we'll send you a reset link.
              </p>

              {error && (
                <div style={{ background:'#7F1D1D', color:'#FCA5A5', padding:'10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ fontSize: 13, color: 'var(--muted)', display:'block', marginBottom: 6 }}>Email address</label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary" style={{ width:'100%' }} disabled={loading}>
                  {loading ? 'Sending...' : 'Send reset link'}
                </button>
              </form>

              <div style={{ textAlign:'center', marginTop: 20 }}>
                <Link to="/login" style={{ color: 'var(--muted)', fontSize: 13 }}>← Back to sign in</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
